(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SEP = '~~';

  // Scope to the PDP section root so the picker (in the CTA), the price (in the
  // label) and the gallery — all siblings under .atl-pdp — are reachable.
  const roots = document.querySelectorAll('.atl-pdp');
  (roots.length ? roots : document.querySelectorAll('[data-pdp-gallery]')).forEach(initPdp);

  function initPdp(root) {
    const gallery = root.querySelector('[data-pdp-gallery]') || root;
    const track = gallery.querySelector('[data-pdp-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-pdp-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-pdp-thumb]'));

    const picker = root.querySelector('[data-atl-picker]');
    const island = root.querySelector('[data-atl-variants]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const hiddenId = root.querySelector('[data-atl-variant-id]');
    const submitBtn = root.querySelector('.atl-pdp-cta__btn--primary');

    let byKey = new Map();
    let byMedia = new Map();
    let selected = [];

    if (picker && island) {
      let variants = [];
      try { variants = JSON.parse(island.textContent); } catch (e) { variants = []; }
      const byId = new Map();
      variants.forEach((v) => {
        byKey.set(v.options.join(SEP), v);
        byId.set(String(v.id), v);
        if (v.media_id != null) byMedia.set(String(v.media_id), v);
      });
      // Map EVERY colour-grouped image to its variant (atelier-product-images.liquid
      // emits the media_id → variant_id pairs). Lets any image — not just a
      // variant's featured one — reverse-sync the picker button on swipe/click.
      const mvEl = root.querySelector('[data-atl-media-variants]');
      if (mvEl) {
        try {
          const mv = JSON.parse(mvEl.textContent);
          Object.keys(mv).forEach((mediaId) => {
            const v = byId.get(String(mv[mediaId]));
            if (v) byMedia.set(String(mediaId), v);
          });
        } catch (e) {}
      }
      selected = readSelected();
    }

    // ---------- gallery helpers ----------
    const behavior = reduce ? 'auto' : 'smooth';
    // Horizontal-only scroll of the image track — never the document. The old
    // scrollIntoView({block:'nearest'}) panned the whole page once the gallery
    // overflowed the viewport. rect math avoids assuming track is an offsetParent.
    const scrollToSlide = (slide) => {
      if (!slide || !track) return;
      const left = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left, behavior });
    };
    const scrollToIndex = (index) => scrollToSlide(slides[index]);
    const scrollToMedia = (mediaId) =>
      scrollToSlide(slides.find((s) => s.dataset.mediaId === String(mediaId)));
    // Keep the active thumb visible by scrolling ITS container — vertical filmstrip
    // on desktop, horizontal rail on mobile — never the page. rect math again.
    const keepThumbInView = (el) => {
      if (!el) return;
      const c = el.parentElement;
      const er = el.getBoundingClientRect();
      const cr = c.getBoundingClientRect();
      if (c.scrollHeight > c.clientHeight + 1) {
        c.scrollTo({ top: c.scrollTop + (er.top - cr.top) - (c.clientHeight - el.clientHeight) / 2, behavior });
      } else if (c.scrollWidth > c.clientWidth + 1) {
        c.scrollTo({ left: c.scrollLeft + (er.left - cr.left) - (c.clientWidth - el.clientWidth) / 2, behavior });
      }
    };
    const setActiveSlide = (index) => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => {
        const on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      keepThumbInView(thumbs[index]);
    };

    // ---------- picker helpers ----------
    function readSelected() {
      return Array.from(picker.querySelectorAll('.atl-pdp-picker__group')).map((g) => {
        const active = g.querySelector('.atl-pdp-picker__btn.is-active') || g.querySelector('.atl-pdp-picker__btn');
        return active ? active.dataset.atlValue : '';
      });
    }
    function setPickerButtons(options) {
      Array.from(picker.querySelectorAll('.atl-pdp-picker__group')).forEach((g, gi) => {
        g.querySelectorAll('.atl-pdp-picker__btn').forEach((btn) => {
          const on = btn.dataset.atlValue === options[gi];
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        // Scroll the chosen button into view inside its strip — mirrors the
        // gallery thumb behaviour. keepThumbInView no-ops when the row doesn't
        // overflow (desktop wrap, short option rows), so this is mobile-strip only.
        const active = g.querySelector('.atl-pdp-picker__btn.is-active');
        if (active) keepThumbInView(active);
      });
    }
    function setUnavailable(state) {
      if (!submitBtn) return;
      submitBtn.disabled = state;
      submitBtn.classList.toggle('is-unavailable', state);
    }
    function applyVariant(variant, doScroll) {
      if (!variant) return;
      selected = variant.options.slice();
      if (picker) setPickerButtons(variant.options);
      if (hiddenId) hiddenId.value = variant.id;
      if (priceEl && variant.price != null) priceEl.textContent = variant.price;
      setUnavailable(!variant.available);
      if (doScroll && variant.media_id != null) scrollToMedia(variant.media_id);
    }

    // picker click → resolve variant → image (scroll)
    if (picker && island) {
      picker.addEventListener('click', (e) => {
        const btn = e.target.closest('.atl-pdp-picker__btn');
        if (!btn) return;
        const group = btn.closest('.atl-pdp-picker__group');
        const gi = Number(group.dataset.optionIndex);
        selected[gi] = btn.dataset.atlValue;
        const variant = byKey.get(selected.join(SEP));
        if (variant) {
          applyVariant(variant, true);
        } else {
          setPickerButtons(selected);   // partial / impossible combo
          setUnavailable(true);
        }
      });
    }

    // Slide becomes active (swipe or thumb): highlight the thumb immediately, but
    // defer the picker reverse-sync until the carousel SETTLES (~150ms idle) so
    // the button doesn't flicker through intermediate colours mid-scroll.
    let settleTimer = null;
    function reverseSyncTo(index) {
      if (!picker || !byMedia.size) return;
      const mediaId = slides[index] && slides[index].dataset.mediaId;
      if (!mediaId) return;
      const variant = byMedia.get(String(mediaId));
      // Guard: only update when this slide maps to a DIFFERENT variant than the
      // current selection. A programmatic scrollToMedia lands on the same variant,
      // so the callback no-ops — no ping-pong.
      if (variant && variant.options.join(SEP) !== selected.join(SEP)) {
        applyVariant(variant, false);
      }
    }
    function onActive(index) {
      setActiveSlide(index);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => reverseSyncTo(index), 150);
    }

    // ---------- carousel wiring ----------
    if (track && slides.length > 1) {
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => { scrollToIndex(i); onActive(i); });
      });
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            const idx = slides.indexOf(entry.target);
            if (idx > -1) onActive(idx);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
  }
})();
